import { cn } from "@/lib/utils";

type Tier = "T1" | "T2" | "T3";

export interface TierBadgeProps {
    tier: Tier | null | undefined;
    className?: string;
}

const TIER_MEANING: Record<Tier, string> = {
    T1: "Tier 1 — top-priority customer",
    T2: "Tier 2 — standard-priority customer",
    T3: "Tier 3 — lower-priority customer",
};

const TIER_STYLES: Record<Tier, string> = {
    T1: "border-amber-500/20 bg-amber-500/10 text-amber-600",
    T2: "border-blue-500/20 bg-blue-500/10 text-blue-600",
    T3: "border-border bg-muted text-foreground/70",
};

/** Compact customer priority tier badge. Renders nothing without a tier. */
export function TierBadge({ tier, className }: TierBadgeProps) {
    if (!tier) return null;
    return (
        <span
            title={TIER_MEANING[tier]}
            className={cn(
                "inline-flex items-center rounded-md border px-1.5 py-0.5 text-[10px] font-semibold leading-normal tracking-wide",
                TIER_STYLES[tier],
                className,
            )}
        >
            {tier}
        </span>
    );
}
